const STORAGE_KEY_PREFIX = /\/(conversations|artifacts|files|document-review)\//

export function isDioptraStorageUrl(href: string): boolean {
  let url: URL
  try {
    url = new URL(href)
  } catch {
    return false
  }
  const host = url.hostname.toLowerCase()
  const isStorageHost =
    host.endsWith(".amazonaws.com") || host.endsWith(".blob.core.windows.net")
  return isStorageHost && STORAGE_KEY_PREFIX.test(url.pathname)
}

export function buildResolveStorageHref(href: string): string {
  return `/resolve-storage-link?u=${encodeURIComponent(href)}`
}
